<template>
    <div>
        <div class="bg-white rounded-xl h-full py-[15px] px-[22px] lg:h-[454px] overflow-y-scroll">
            <div class="trix" v-html="resource.teaching_tips?.replace(/<a/g, '<a target=\'_blank\'')" ref="teachingTips"></div>
            <div v-if="resource.scientist_notes" class="trix mt-4" v-html="resource.scientist_notes?.replace(/<a/g, '<a target=\'_blank\'')" ref="scientistNotes"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        resource: Object
    },
    mounted() {
        this.$nextTick(() => {
            this.setExternalLinks();
        });
    },
    watch: {
        'resource.teaching_tips'() {
            this.$nextTick(() => { this.setExternalLinks(); });
        },
        'resource.scientist_notes'() {
            this.$nextTick(() => { this.setExternalLinks(); });
        }
    },
    methods: {
        setExternalLinks() {
            ['teachingTips', 'scientistNotes'].forEach(ref => {
                const el = this.$refs[ref];
                if (el) {
                    el.querySelectorAll('a').forEach(link => {
                        link.setAttribute('target', '_blank');
                        link.setAttribute('rel', 'noopener noreferrer');
                    });
                }
            });
        }
    }
}
</script>
